/**
 * Typed wrappers for the custom (non-CRUD) super-admin Company endpoints.
 *
 * Standard CRUD (list/get/create/update) goes through Refine's dataProvider;
 * archive/restore are custom verbs, so they live here. Both target the
 * `{id:guid}` sibling routes and — for archive — echo the id back as
 * `targetCompanyId`, the backend's explicit cross-tenant confirmation.
 */
import { superadminFetch } from './dataProvider';

/** POST /v1/superadmin/companies/{id}/archive — body confirms the target tenant. */
export async function archiveCompany(id: string): Promise<void> {
  await superadminFetch<void>(`/v1/superadmin/companies/${id}/archive`, {
    method: 'POST',
    body: JSON.stringify({ targetCompanyId: id }),
  });
}

/** POST /v1/superadmin/companies/{id}/restore — no body. */
export async function restoreCompany(id: string): Promise<void> {
  await superadminFetch<void>(`/v1/superadmin/companies/${id}/restore`, {
    method: 'POST',
  });
}
